var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},[_c('rect',{attrs:{"id":"Rectangle_852","data-name":"Rectangle 852","width":"14","height":"14"}})])}
var staticRenderFns = []

export { render, staticRenderFns }